import type { SVGProps } from "react";

import { BreadIcon } from "@/shared/icons/BreadIcon";
import { CheeseburgerIcon } from "@/shared/icons/CheeseburgerIcon";
import { CloudSnowIcon } from "@/shared/icons/CloudSnowIcon";
import { CoffeeMugIcon } from "@/shared/icons/CoffeeMugIcon";
import { CoffeeTakeAwayIcon } from "@/shared/icons/CoffeeTakeAwayIcon";
import { PlusIcon } from "@/shared/icons/PlusIcon";
import { RomanticRestaurantIcon } from "@/shared/icons/RomanticRestaurantIcon";
import { ScooterIcon } from "@/shared/icons/ScooterIcon";
import { ShopIcon } from "@/shared/icons/ShopIcon";
import { StarIcon } from "@/shared/icons/StarIcon";
import type { IconName } from "@/shared/types/icon-name";

export type { IconName };

const ICON_MAP = {
  BreadIcon,
  CheeseburgerIcon,
  CloudSnowIcon,
  CoffeeMugIcon,
  CoffeeTakeAwayIcon,
  PlusIcon,
  RomanticRestaurantIcon,
  ScooterIcon,
  ShopIcon,
  StarIcon,
} as const satisfies Record<IconName, React.FC<SVGProps<SVGSVGElement>>>;

interface UniversalIconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number | string;
  color?: string;
}

export const Icon = ({
  name,
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}: UniversalIconProps) => {
  const SvgIcon = ICON_MAP[name];

  if (!SvgIcon) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <SvgIcon size={size} color={color} className={className} {...props} />
  );
};
